module.exports = __webpack_public_path__ + "img/login_bg.d11b8df2.png";